import { handleActions } from 'redux-actions';
import {
  trialBalanceMapedElementsLoading,
  trialBalanceMapedElementsLoaded,
  trialBalanceMapedElementsError,
  clearTrialBalanceMapedElements,
  setTBSourceElementClicked,
  removeTBSourceElementClicked,
  setTBTargetElementClicked,
  removeTBTargetElementClicked,
  resetMappedElements,
} from 'store/actions/trial-balance/mapped-element-action';
import TrialBalanceMappedElements from 'models/api/trial-balance/mapped-elements-api-model';

export default handleActions(
  {
    [trialBalanceMapedElementsLoading]: (trialBalanceMappedElements) => {
      return trialBalanceMappedElements.setLoading();
    },
    [trialBalanceMapedElementsLoaded]: (
      trialBalanceMappedElements,
      { payload },
    ) => {
      return trialBalanceMappedElements.setLoaded(payload);
    },
    [trialBalanceMapedElementsError]: (
      trialBalanceMappedElements,
      { payload },
    ) => {
      return trialBalanceMappedElements.setError(payload);
    },
    [clearTrialBalanceMapedElements]: (trialBalanceMappedElements) => {
      return trialBalanceMappedElements.clear();
    },
    [setTBSourceElementClicked]: (trialBalanceMappedElements, { payload }) => {
      return trialBalanceMappedElements.setSourceElementClicked(payload);
    },
    [removeTBSourceElementClicked]: (trialBalanceMappedElements) => {
      return trialBalanceMappedElements.setSourceElementClicked(null);
    },
    [setTBTargetElementClicked]: (trialBalanceMappedElements, { payload }) => {
      return trialBalanceMappedElements.setTargetElementClicked(payload);
    },
    [removeTBTargetElementClicked]: (trialBalanceMappedElements) => {
      return trialBalanceMappedElements.setTargetElementClicked(null);
    },
    [resetMappedElements]: () => {
      return new TrialBalanceMappedElements();
    },
  },
  new TrialBalanceMappedElements(),
);
